module.exports = __webpack_public_path__ + "img/Rectangle 1481@2x.a34446e2.png";